module.exports = __webpack_public_path__ + "static/media/terminal.21a6adca.svg";